'use es6';

import http from 'hub-http/clients/apiClient';
export var sendRequestAccessNotification = function sendRequestAccessNotification(merchandiseId) {
  return http.post('monetization-service/v2/request/access-owned', {
    data: {
      merchandiseId: merchandiseId
    }
  });
};
export var sendRequestAdditionalSeatsNotification = function sendRequestAdditionalSeatsNotification(merchandiseId) {
  return http.post('monetization-service/v2/request/additional-seats', {
    data: {
      merchandiseId: merchandiseId
    }
  });
};
export var sendRequestSKUNotification = function sendRequestSKUNotification(merchandiseId) {
  return http.post('monetization-service/v2/request/sku', {
    data: {
      merchandiseId: merchandiseId
    }
  });
};
export var sendRequestTrialNotification = function sendRequestTrialNotification(merchandiseId) {
  return http.post('monetization-service/v2/request/trial', {
    data: {
      merchandiseId: merchandiseId
    }
  });
};
export var sendRequestRemoteToolsNotification = function sendRequestRemoteToolsNotification() {
  return http.post('/monetization-service/v2/request/free-remote-sales-tools');
};
export var sendRequestProductActivationNotification = function sendRequestProductActivationNotification(merchandiseId) {
  return http.post('monetization-service/v2/request/product', {
    data: {
      merchandiseId: merchandiseId
    }
  });
};
export var sendRequestQuotePurchaseNotification = function sendRequestQuotePurchaseNotification(hub) {
  return http.post('monetization-service/v2/request/quote-purchase', {
    data: {
      hub: hub
    }
  });
};